import { getVocabWordListFromString, usePacketInput } from '../Contexts/PacketInputContext';
import { useEffect, useRef } from 'react';
import { VOCABULARY_ID } from '../Contexts/PacketInputContext';

export const VocabularyInput = () => {
  const { inputType, words, setWords } = usePacketInput();
  const textareaRef = useRef(null);

  useEffect(() => {
    // Auto-focus when this tab becomes active
    if (inputType.id === VOCABULARY_ID && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [inputType.id]);

  if (inputType.id !== VOCABULARY_ID) return null;

  return (
    <div className='pt-1'>
      <textarea
        ref={textareaRef}
        value={words}
        onChange={(e) => setWords(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            const numWords = getVocabWordListFromString(words).length;
            if (numWords >= 20) {
              e.preventDefault();
              return;
            }
          }
        }}
        placeholder='Enter up to 20 vocabulary words or terms (one per line)'
        className={`w-full px-2 pt-5 pb-8 ${words ? 'resize-y' : 'resize-none'} border-none focus:ring-0 placeholder:text-gray-400 placeholder:font-light caret-emerald-600 scrollbar-minimal overflow-y-auto h-32`}
      />
      {getVocabWordListFromString(words).length >= 20 && (
        <div className='text-xs text-red-600'>You've reached the word limit.</div>
      )}
    </div>
  );
};
